import {
  getEnumValuesFromPipelineSchema,
  getMinMaxSchemaValue,
} from '@flows/configs/shared/schemaUtils'
import { BaseSchema_ContentsV1GetsafeDe as schema } from '@flows/insurance/schemas'
import { getClaimsOptions } from '@flows/insurance/utils/stepContentUtils'

const deductiblesOptionsFromSchema = getEnumValuesFromPipelineSchema(schema.shape.deductible_amount)
const claimsOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.number_of_claims_in_last_5y.unwrap()
)

export const CONTENTS_NXT_CONSTANTS = {
  deductiblesOptions: deductiblesOptionsFromSchema,
  claimsOptions: getClaimsOptions(claimsOptionsFromSchema.length),
  defaultSquareMeterPrice: 650,
  maxCustomerAge: 120,
  insuredSumValidation: {
    min: getMinMaxSchemaValue(schema.shape.insured_sum_amount.innerType(), 'min'),
    max: getMinMaxSchemaValue(schema.shape.insured_sum_amount.innerType(), 'max'),
  },
  insuredSumBikeValidation: {
    min: getMinMaxSchemaValue(
      schema.shape.bike_theft_insured_sum_amount.unwrap().innerType(),
      'min'
    ),
    max: getMinMaxSchemaValue(
      schema.shape.bike_theft_insured_sum_amount.unwrap().innerType(),
      'max'
    ),
  },
  livingSpaceValidation: {
    min: getMinMaxSchemaValue(schema.shape.living_space_square_meters.innerType(), 'min'),
    max: getMinMaxSchemaValue(schema.shape.living_space_square_meters.innerType(), 'max'),
  },
}
